// src/ChatBotContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { chatbotModules } from './chatbotConfig';
// Create the context
const ChatBotContext = createContext();
// Helper function to determine the current module based on path
const getModuleFromPath = (path) => {
  // Extract the main route segment
  const mainSegment = path.split('/')[2] || '';
  // Match the segment to a module, or use default
  return chatbotModules[mainSegment] || chatbotModules.default;
};
// Provider component
export const ChatBotProvider = ({ children }) => {
  const location = useLocation();
  const [currentModule, setCurrentModule] = useState(getModuleFromPath(location.pathname));
  // Update the module when the location changes
  useEffect(() => {
    setCurrentModule(getModuleFromPath(location.pathname));
  }, [location.pathname]);
  // Value to be provided to consumers
  const value = {
    currentModule,
    allModules: chatbotModules
  };
  return (
    <ChatBotContext.Provider value={value}>
      {children}
    </ChatBotContext.Provider>
  );
};
// Custom hook for using the chatbot context
export const useChatBot = () => {
  const context = useContext(ChatBotContext);
  if (!context) {
    throw new Error('useChatBot must be used within a ChatBotProvider');
  }
  return context;
};